"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
//import { PlayerLevelTitlesListCtl, IPlayerLevelTitlesListItem } from "../../../ctl/PlayerLevelTitlesListCtl";
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var PlayerLevelAttributeEditor = /** @class */ (function (_super) {
    __extends(PlayerLevelAttributeEditor, _super);
    function PlayerLevelAttributeEditor(props) {
        return _super.call(this, props) || this;
    }
    PlayerLevelAttributeEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    attr_key: _item.attr_key,
                    attr_val: _item.attr_val
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                app_currency_id: 0,
                app_currency_title: "",
                attr_key: "",
                attr_val: ""
            });
        }
        this.doReSetRules();
    };
    PlayerLevelAttributeEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
            app_currency_rules: { isError: false },
            attr_key_rules: { isError: false },
            attr_val_rules: { isError: false }
        });
    };
    PlayerLevelAttributeEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык не выбран!" } });
            return false;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
            return false;
        }
        if ((!this.state.attr_key) || (this.state.attr_key.length === 0)) {
            this.setState({ attr_key_rules: { isError: true, errorMessage: "Ключ аттрибута не заполнен!" } });
            return false;
        }
        if ((!this.state.attr_val) || (this.state.attr_val.length === 0)) {
            this.setState({ attr_val_rules: { isError: true, errorMessage: "Значение аттрибута не заполнено!" } });
            return false;
        }
        return true;
    };
    PlayerLevelAttributeEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                app_currency_id: this.state.app_currency_id,
                attr_key: this.state.attr_key,
                attr_val: this.state.attr_val
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Аттрибут уровня изменен!");
            });
        }
    };
    PlayerLevelAttributeEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                app_currency_id: this.state.app_currency_id,
                brand_bonus_level_id: this.props.rootRecord.key,
                attr_key: this.state.attr_key,
                attr_val: this.state.attr_val
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Аттрибут уровня добавлен!");
            });
        }
    };
    PlayerLevelAttributeEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerLevelAttributeEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый аттрибут уровня";
        }
        else {
            return "Изменить аттрибут уровня";
        }
    };
    PlayerLevelAttributeEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 380 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Ключ:", placeholder: "Введите ключ" }, value: this.state.attr_key, onValueChanged: function (newVal) { _this.setState({ attr_key: newVal, attr_key_rules: { isError: false } }); }, required: true, rules: this.state.attr_key_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Значение:", placeholder: "Введите значение" }, value: this.state.attr_val, onValueChanged: function (newVal) { _this.setState({ attr_val: newVal, attr_val_rules: { isError: false } }); }, required: true, rules: this.state.attr_val_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguages, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PlayerLevelAttributeEditor;
}(React.Component));
exports.default = PlayerLevelAttributeEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/cfg_attributes/PlayerLevelAttributeEditor.tsx
// module id = 1951
// module chunks = 0